__turbopack_context__.v({
  "breadcrumbs": "Intro-module__bVxVra__breadcrumbs",
  "content": "Intro-module__bVxVra__content",
  "large": "Intro-module__bVxVra__large",
  "preamble": "Intro-module__bVxVra__preamble",
  "root": "Intro-module__bVxVra__root",
  "sideBySide": "Intro-module__bVxVra__sideBySide",
  "title": "Intro-module__bVxVra__title",
});
